import { useHits, useInstantSearch } from 'react-instantsearch'

import GridArchiveItem from '@/components/grid-archive/GridArchiveItem'
import PromoBlock from '@/components/promo-block/PromoBlock'

import type { Hit } from 'instantsearch.js'

type GridItemsProps = {
  isFiltered?: boolean
  disableFeatured?: boolean
}

export default function GridArchiveItems({ isFiltered = false, disableFeatured = false }: GridItemsProps): JSX.Element {
  // Main query items (excludes featured)
  const { items } = useHits()
  const { results } = useInstantSearch()

  const currentPage = results?.page || 0
  const isFirstPage = currentPage === 0

  const gridRowClass =
    'grid w-full grid-cols-5 items-start gap-l xl:grid-cols-4 l:grid-cols-3 m:grid-cols-2 s:gap-x-s [@media(max-width:380px)]:grid-cols-1'

  // If filtered, show all results in a single grid (no featured section)
  if (isFiltered) {
    return (
      <div className={gridRowClass} style={{ viewTransitionName: 'grid-transition' }}>
        {items?.length ? (
          items.map((item: Hit) => (
            <GridArchiveItem key={item.objectID} hit={item} enableBookmark={false} />
          ))
        ) : (
          <p>No results could be found</p>
        )}
      </div>
    )
  }

  // Unfiltered view: main grid (featured is rendered separately)
  return (
    <>
      {/* Promo block - only on page 1 when featured is enabled */}
      {isFirstPage && !disableFeatured ? (
        <div className="bg-theme py-0 text-fg breakout theme--gradient-light">
          <PromoBlock
            title="Sign up to receive the latest News & Insights"
            text="Get the latest news and updates from our team."
            link={{
              url: '/newsletter',
              title: 'Register',
              target: '_blank',
            }}
          />
        </div>
      ) : null}

      {/* Main grid items */}
      <div className={gridRowClass} style={{ viewTransitionName: 'grid-transition' }}>
        {items?.length ? (
          items.map((item: Hit) => (
            <GridArchiveItem key={item.objectID} hit={item} enableBookmark={false} />
          ))
        ) : (
          <p>No results could be found</p>
        )}
      </div>
    </>
  )
}
